import React, { useEffect, useState } from 'react';
import { CheckCircle2Icon } from 'lucide-react';
export const TextArea = ({
  id,
  label,
  value,
  onChange,
  placeholder = '',
  rows = 3,
  error = null,
  touched = false,
  onBlur = () => {},
  required = false,
  disabled = false,
  helperText = '',
  className = '',
  premium = false
}) => {
  const [isFocused, setIsFocused] = useState(false);
  const [isDirty, setIsDirty] = useState(false);
  const [localError, setLocalError] = useState(error);
  // Check if field has a value
  const hasValue = value && value.trim() !== '';
  // Update validation state when value changes
  useEffect(() => {
    if (hasValue) {
      setLocalError(null);
    } else if (required && touched && isDirty) {
      setLocalError(error);
    }
  }, [value, error, required, touched, isDirty, hasValue]);
  const showError = localError && touched && isDirty;
  const isValid = hasValue && !localError && isDirty;
  const handleBlur = e => {
    setIsFocused(false);
    setIsDirty(true);
    onBlur(e);
  };
  const handleChange = e => {
    onChange(e);
    if (e.target.value.trim() !== '') {
      setLocalError(null);
    }
    setIsDirty(true);
  };
  return <div className={className} data-id="element-537">
      {label && <label htmlFor={id} className="block text-[12px] font-medium text-gray-600 mb-1" data-id="element-538">
          {label} {required && <span className="text-red-500" data-id="element-539">*</span>}
        </label>}
      <div className="relative" data-id="element-540">
        <textarea id={id} value={value} onChange={handleChange} onFocus={() => setIsFocused(true)} onBlur={handleBlur} placeholder={placeholder} rows={rows} disabled={disabled} className={`block w-full rounded-md transition-all duration-200 bg-white
            ${showError ? 'border-red-500 pr-10 focus:ring-red-500 focus:border-red-500' : isValid ? 'border-green-500 pr-10 focus:ring-green-500 focus:border-green-500' : isFocused ? 'border-[#FCCA86] ring-1 ring-[#FCCA86] border-2' : 'border-gray-300 border hover:border-gray-400 shadow-sm'} 
            px-3 py-2 text-[14px] focus:outline-none focus:ring-1
            ${disabled ? 'bg-gray-100 opacity-75' : ''}`} data-id="element-541" />
        {showError && <div className="absolute top-3 right-3 pointer-events-none" data-id="element-542">
            <svg className="h-5 w-5 text-red-500" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true" data-id="element-543">
              <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" data-id="element-544" />
            </svg>
          </div>}
        {isValid && <div className="absolute top-3 right-3 pointer-events-none" data-id="element-545">
            <CheckCircle2Icon className="h-5 w-5 text-green-500" data-id="element-546" />
          </div>}
      </div>
      {helperText && !showError && <p className="mt-1 text-xs text-gray-500" data-id="element-547">{helperText}</p>}
      {showError && <p className="mt-1 text-xs text-red-600" data-id="element-548">{localError}</p>}
    </div>;
};